import ActionTypes from "../../../../../constants/ActionTypes";
import { IProduct } from "../../../../../entities/product/types";

export function setRecentlyViewedProducts(products: IProduct[]) {
  return {
    type: ActionTypes.PRODUCT.SET_RECENTLY_VIEWED,
    payload: {
      products,
    }
  };
}

export function setRecentlyViewedProductInLocalStorage(product: IProduct) {
  return {
    type: ActionTypes.PRODUCT.SET_RECENTLY_VIEWED_IN_LOCAL_STORAGE,
    payload: {
      product,
    }
  };
}

export function getRecentlyViewedProducts() {
  return {
    type: ActionTypes.PRODUCT.GET_RECENTLY_VIEWED,
  };
}

export function transformProductResponse() {
  return {
    type: ActionTypes.PRODUCT.TRANSFORM_PRODUCT_RESPONSE,
  };
}
